<template>
  <button class="q-btn q-btn q-btn-sm q-bg-white q-dropdown-toggle  q-pe-5 q-position-relative q-mb-1 q-rounded-3  q-shadow-sm q-fw-semibold" :class="{'dropdown__open': isOpen}" type="button"
          aria-expanded="false">
    {{ label }}
  </button>
</template>
<script setup lang="ts">
import {defineProps} from 'vue';

defineProps(['label', 'isOpen'])
</script>
<style>
.q-dropdown-toggle::after {
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  content: "";
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-size: 1.25rem;
  display: inline-block;
  position: absolute;
  right: 5px;
  bottom: 4px;
}
 .q-dropdown-toggle:hover, .q-dropdown-toggle:focus{
  border: 1px solid transparent!important;
  background-color: #eaeaea !important;
}
.q-dropdown-toggle:active{
  background-color: #fff!important;
  border: 1px solid transparent!important;
}

/*.q-dropdown-toggle:hover::after {*/
/*  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");*/
/*}*/
.q-dropdown-toggle.dropdown__open::after{
  transform: rotate(180deg);
}

</style>
